import * as CryptoJS from 'crypto-js';

export const encrypt = (value: string) => {
  return CryptoJS.AES.encrypt(value, process.env.CRYP_ENC).toString()
};

export const decrypt = (hash: string) => {
  return CryptoJS.AES.decrypt(hash, process.env.CRYP_ENC).toString(CryptoJS.enc.Utf8)
}
